import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import LogoRBF from "../../assets/logos/rbf-logo.svg?url";
import NameDateWrapper from "./../header/name-date-wrapper";

import { defaultLocale } from "../app";
import DashedBorder from "./dashed-border";
import { AnimatePresence, motion } from "framer-motion";
import { timetableBreakpointAction } from "../app-actions";

const LogoButton = () => {
  const currentLanguage = useSelector((state) => state.i18n.currentLanguage);
  const isConferenceOverviewPage = useSelector(
    (state) => state.appStore.isConferenceOverviewPage
  );
  const persistViewSwitch = useSelector(
    (state) => state.appStore.persistViewSwitch
  );
  const timetableBreakpoint = useSelector(
    (state) => state.appStore.timetableBreakpoint
  );
  const Logo = () => <img src={LogoRBF} className={"logo"} alt={"RBF Logo"} />;

  let link = "/";

  if (currentLanguage !== "und" && defaultLocale !== currentLanguage) {
    link = `/${currentLanguage}`;
  }

  const hideNameDateWrapper =
    !timetableBreakpoint && (isConferenceOverviewPage || persistViewSwitch);

  return (
    <Link className="site-logo-button navigation-element" to={link}>
      <DashedBorder blurredBackdrop={true} reverse />
      <Logo />

      <AnimatePresence>
        {!hideNameDateWrapper && (
          <motion.div
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: "auto", opacity: 1 }}
            exit={{ width: 0 }}
          >
            <NameDateWrapper />
          </motion.div>
        )}
      </AnimatePresence>
    </Link>
  );
};

export default LogoButton;
